import { createFileRoute, redirect } from '@tanstack/react-router';
import {
  defaultAbateParams,
  normalizeMes,
  normalizeTipoAno,
  RelatorioTransacoesPage,
} from '../../-RelatorioTransacoesPage';

export const Route = createFileRoute('/_authenticated/relatorio-transacoes/$tipo/$ano/$mes')({
  beforeLoad: ({ params }) => {
    const { tipo, ano } = normalizeTipoAno(params);
    if (tipo !== 'abate') {
      return redirect({
        to: '/relatorio-transacoes/$tipo/$ano',
        params: { tipo, ano },
        replace: true,
      });
    }
    const mes = normalizeMes(params.mes);
    if (tipo !== params.tipo || ano !== params.ano || mes !== params.mes) {
      return redirect({
        to: '/relatorio-transacoes/$tipo/$ano/$mes',
        params: { tipo: 'abate', ano, mes },
        replace: true,
      });
    }
  },
  component: RelatorioTransacoesAbateRoute,
});

function RelatorioTransacoesAbateRoute() {
  const { tipo, ano, mes } = Route.useParams();
  return (
    <RelatorioTransacoesPage
      tipo={tipo}
      ano={ano}
      mes={mes}
    />
  );
}
